import { CustomerPaymentMethodModel } from './../models/Profile/CustomerPaymentMethodModel';
import { NationalitieModel } from './../models/Profile/NationalitieModel';
import { LocationModel } from './../models/Location/LocationModel';
import { CustomerSummaryModel } from './../models/Profile/CustomerSummaryModel';
import { ApiControllerActionEnum } from './../models/enums/ApiControllerActionEnum';

import { signUpUserModel } from './../models/signUpUserModel';
import { User } from './../models/user';
import { Customer } from './../models/Customer';
//import { User } from './../views/auth/User';
//import { JwtHelper } from 'angular2-jwt';
import { environment } from './../../environments/environment.prod';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, tap, concatMap, retry, catchError } from 'rxjs/operators';
import { BehaviorSubject, throwError } from 'rxjs';
import { ResourceService } from './resource.service';
import { LanguageModel } from '../models/LanguageModel';
import { CurrencyModel } from '../models/CurrencyModel';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user: User;
  token: string;

  private _loggedInUser = new BehaviorSubject<any>({});
  readonly loggedInUser = this._loggedInUser.asObservable();

  private _loggedInCustomer = new BehaviorSubject<any>(null);
  readonly loggedInCustomer = this._loggedInCustomer.asObservable();

  private dataStore: { loggedInUser: any, loggedInCustomer: any } = { loggedInUser: {}, loggedInCustomer: null };

  private selectedCurrency: CurrencyModel;



  public loggedInStatus: boolean = false;
  selectedLanguage: LanguageModel;
  selectedLanguageIsoCode: string;
  constructor(private http: HttpClient,resouceService: ResourceService) {
    resouceService.selectedCurrency.subscribe(res => this.selectedCurrency = res);
    var user = JSON.parse(this.GetUserStorage())
    if (user != null) {

      this.dataStore.loggedInUser = user;
      this._loggedInUser.next(Object.assign({}, this.dataStore).loggedInUser);

    }
    let customer=JSON.parse(this.getCachedCustomer());
    if (customer != null) {
      this.saveCustomer(customer);
    }
    resouceService.selectedLanguage.subscribe(res => {

      this.selectedLanguage = res;
      if (res != null) {
        this.selectedLanguageIsoCode = res.isoCode2;
      }
    })

  }

  public login(userInfo: User) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    userInfo.username = userInfo['email'];
    //this.http.post('User/Authenticate', {Username:"",Password:""}).subscribe();
    return this.http.post<any>('Account/Login', JSON.stringify(userInfo), httpOptions)
      .pipe(
        /*         retry(1),
                catchError(this.handleError), */
        map(res => {



          let response = JSON.parse(JSON.stringify(res))
          if (response && response.token) {
            this.doLogin(response);
            return true;
          }
          return false;

        }
        ));
    /*        return this.http.post('Account/Login', JSON.stringify(userInfo))
          .pipe(
            tap(response => {
            this.doLogin(JSON.stringify(response));
          }),
          concatMap(()=> this.GetUser() ),
          map(()=> { if(this.token)return true; else return false;})
          ); */
  }
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    return throwError(errorMessage);
  }

  private doLogin(response) {

    this.saveUser(response);
    this.saveCustomer(response.customerModel);
    this.token = response.token;

    //Todo : Save User Information
    this.saveToken(this.token);
  }
  private saveToken(token) {
    this.loggedInStatus = true;
    //localStorage.setItem('ACCESS_TOKEN', token);
    sessionStorage.setItem('ACCESS_TOKEN', token);
  }
  public saveCustomer(customer) {


    //Save the User in the Store
    this.dataStore.loggedInCustomer = customer;
    this._loggedInCustomer.next(Object.assign({}, this.dataStore).loggedInCustomer);

    //Save the User in the Local Storage
    sessionStorage.removeItem('Customer');
    sessionStorage.setItem('Customer', JSON.stringify(customer));


  }
  public cachedCustomer(customer){

    sessionStorage.setItem('Customer', JSON.stringify(customer));
  }
  public getCachedCustomer(){

    return sessionStorage.getItem('Customer');
  }
  private saveUser(user) {
    //Save the User in the Store
    this.dataStore.loggedInUser = user;
    this._loggedInUser.next(Object.assign({}, this.dataStore).loggedInUser);
    //Save the User in the Local Storage
    sessionStorage.setItem('User', JSON.stringify(user));
  }
  public GetUserStorage() {
    return sessionStorage.getItem('User');
  }
  public GetCustomerStorage() {
    return sessionStorage.getItem('Customer');
  }


  public isLoggedIn() {

    if (sessionStorage.getItem('ACCESS_TOKEN')) {
      /* var jwt = new JwtHelper();
      jwt.isTokenExpired(localStorage.getItem('ACCESS_TOKEN')); */
    }

    return sessionStorage.getItem('ACCESS_TOKEN') !== null && sessionStorage.getItem('User') !== null;
  }
  public GetUser() {
    return this.http.get('Account/GetUser')
      .pipe(map(res => {
        let _user = (<User>res);
        this.user = _user;
      }),
      );
  }
  public logout() {
    //localStorage.removeItem('ACCESS_TOKEN');
    sessionStorage.removeItem('User');
    sessionStorage.removeItem('Customer');
    sessionStorage.removeItem('ACCESS_TOKEN');
    this.loggedInStatus = false;
    //Remove the User From the Store
    this.dataStore.loggedInUser = {};
    this._loggedInUser.next(Object.assign({}, this.dataStore).loggedInUser);


  }
  public getToken(): string {

    return sessionStorage.getItem('ACCESS_TOKEN');
  }

  public signUp(userInfo) {


    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }

    //this.http.post('User/Authenticate', {Username:"",Password:""}).subscribe();
    return this.http.post('Account/Register', JSON.stringify(userInfo), httpOptions)
      .pipe(map(res => {

        let response = JSON.parse(JSON.stringify(res))
        if (response && response.token) {
          this.doLogin(response);
          return true;
        }
        return false;

      }
      ));
  }

  public checkIfEmailExist(email) {
    return this.http.get(`Account/CheckEmailIfExist/${email}`);
  }

  public forgotPassword(email) {
    return this.http.post(ApiControllerActionEnum.ForgotPassword + `?email=${email}`, {});
  }

  getCustomerSummary(customerID) {

    return this.http.post<CustomerSummaryModel>(ApiControllerActionEnum.GetCustomerSummary + `?customerID=${customerID}&lang=${this.selectedLanguageIsoCode}&currencyID=${this.selectedCurrency.currencyID}`, {})
  }
  getCustomerLocation(parentID) {
    let param='';
    if(parentID!=null){
      param+=`?parentID=${parentID}`;
      param+=`&lang=${this.selectedLanguageIsoCode}`;

    }
    return this.http.get<Array<LocationModel>>(ApiControllerActionEnum.GetLocation +param );
  }
  getNationalities(){
    return this.http.post<NationalitieModel>(ApiControllerActionEnum.GetNationalities+`?lang=${this.selectedLanguageIsoCode}`,{})
  }

  addCustomerPaymentMethods(model){
    return this.http.post(ApiControllerActionEnum.AddCustomerPaymentMethods,JSON.stringify(model));
  }
  getCustomerPaymentMethods(customerID){
    return this.http.get<Array<CustomerPaymentMethodModel>>(ApiControllerActionEnum.GetCustomerPaymentMethods +`?customerID=${customerID}` );
  }
  deleteCustomerPaymentMethods(customerPaymentMethodID){
    return this.http.get<Array<CustomerPaymentMethodModel>>(ApiControllerActionEnum.DeleteCustomerPaymentMethods +`?customerPaymentMethodID=${customerPaymentMethodID}` );
  }
  updateCustomerPaymentMethods(model){
    return this.http.post(ApiControllerActionEnum.UpdateCustomerPaymentMethods,JSON.stringify(model));
  }

  resetPassword(model){
    return this.http.post(ApiControllerActionEnum.ResetPassword,JSON.stringify(model));
  }

  changePassword(model){
    return this.http.post(ApiControllerActionEnum.ChangePassword,JSON.stringify(model));
  }

  changeEmail(model){
    return this.http.post(ApiControllerActionEnum.ChangeEmail,JSON.stringify(model));
  }


}
